import { ParticipantId } from 'src/app/components/participant/store/participant.model';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, takeUntil } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ProjetPrpfessionnelState } from '../../store/projet-professionnel.reducer';
import { Store } from '@ngrx/store';
import * as fromProjetProAction from '../../store/projet-professionnel.actions';
import * as fromProjetProSelector from '../../store/projet-professionnel.selectors';
import { ProjetProfessionnelEntitesFormComponent } from '../projet-professionnel-entites-form/projet-professionnel-entites-form.component';

@Component({
  selector: 'app-projet-professionnel-entites',
  templateUrl: './projet-professionnel-entites.component.html',
  styleUrls: ['./projet-professionnel-entites.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjetProfessionnelEntitesComponent
  implements OnInit, OnChanges, OnDestroy
{
  loading$: Observable<boolean> = of(false);
  entites$: Observable<any> = of(null);
  subscribe = new Subject();
  currentFilter = new BehaviorSubject<any>(null);
  modalWidth: number = 960;
  title: string = 'Nouvelle entité projet professionnel';
  view$ = new BehaviorSubject<string>('list');
  current$ = new BehaviorSubject<any>(null);
  newCardTitle: string = 'Nouvelle entité projet professionnel';
  newCardDescription: string = 'Ajouter une entité projet professionnel';
  newCardDefinition: string =
    'Une entité projet professionnel est une companie en capacité de participer à la réalisation du projet.';

  @ViewChild('projetProfessionnelEntiteForm', { static: false })
  projetProfessionnelEntiteForm: TemplateRef<any> | any;

  @Input() projetprofessionnel$ = new BehaviorSubject<any>(null);
  @Input() participant: ParticipantId | any = null;

  constructor(
    private projetProfessionnelStore: Store<ProjetPrpfessionnelState>,
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.getEntitesProjetpro();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadEntites(changes.participant.currentValue);
  }

  getLoading(): void {
    this.loading$ = this.projetProfessionnelStore.select(
      fromProjetProSelector.loading
    );
  }
  getEntitesProjetpro(): void {
    this.entites$ = this.projetProfessionnelStore.select(
      fromProjetProSelector.entites
    );
  }

  loadEntites(participant: ParticipantId): void {
    if (!participant) return;
    this.projetprofessionnel$
      .pipe(takeUntil(this.subscribe))
      .subscribe((projetPro: any) => {
        if (!projetPro) return;

        this.projetProfessionnelStore.dispatch(
          fromProjetProAction.loadEntitesProjetPro({
            participantId: participant.id,
            projetpro: projetPro,
          })
        );
      });
  }

  onSelect(formation: any): void {
    this.current$.next(formation);
    //this.view$.next('details');
  }

  onBack(): void {
    this.current$.next(null);
    this.view$.next('list');
  }

  onNew(participant: any, projet: any): void {
    if (!participant || !projet) return;
    const modal = this.modal.create({
      nzContent: ProjetProfessionnelEntitesFormComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzWidth: this.modalWidth,
      nzFooter: [],
      nzTitle: this.projetProfessionnelEntiteForm,
      nzComponentParams: {},
      nzCloseIcon: '',
      nzClosable: false,
      nzStyle: { top: '20px' },
    });
    const instance = modal.getContentComponent();
    instance.item.next(projet);
    instance.cancel.subscribe((event): any => {
      if (!event) {
        return null;
      } else {
        modal.close();
      }
    });
    instance.add.subscribe((entite): any => {
      if (!entite) {
        return null;
      } else {
        this.onAdd(participant, projet, entite);
        modal.close();
      }
    });
  }

  onAdd(participant: any, projet: any, entite: any): void {
    if (!participant || !projet || !entite) return;
    this.projetProfessionnelStore.dispatch(
      fromProjetProAction.addEntiteProjetPro({
        participantId: participant.id,
        projetpro: projet,
        entite: entite,
      })
    );
  }

  onUpdate(participant: any, projet: any, entite: any): void {
    if (!participant || !projet || !entite) return;
  }

  onDelete(entite: any, participant: any, projet: any): void {
    if (!participant || !projet || !entite) return;
    this.projetProfessionnelStore.dispatch(
      fromProjetProAction.deleteEntiteProjetPro({
        participantId: participant.id,
        projetpro: projet,
        id: entite.id,
      })
    );
  }

  onCancel(): void {
    return;
  }
  ngOnDestroy(): void {
    this.subscribe.next(null);
    this.subscribe.complete();
  }
}
